import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { ScrollView, StyleSheet, Switch, Text, TouchableOpacity, View } from 'react-native';

interface SettingItem {
  id: string;
  label: string;
  type: 'switch' | 'arrow';
  value?: boolean;
  onPress: () => void;
}

export default function SettingsScreen() {
  const navigation = useNavigation();

  const [settings, setSettings] = useState({
    messageNotification: true,
    soundNotification: true,
    vibration: true,
    showOnlineStatus: true,
    readReceipt: true,
    autoDownload: false,
    darkMode: false,
  });

  const [messageSize, _setMessageSize] = useState<string>('50');

  const toggleSetting = (key: keyof typeof settings) => {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const settingItems: SettingItem[] = [
    {
      id: 'messageNotification',
      label: '接收消息通知',
      type: 'switch',
      value: settings.messageNotification,
      onPress: () => toggleSetting('messageNotification'),
    },
    {
      id: 'soundNotification',
      label: '消息提示音',
      type: 'switch',
      value: settings.soundNotification,
      onPress: () => toggleSetting('soundNotification'),
    },
    {
      id: 'vibration',
      label: '震动反馈',
      type: 'switch',
      value: settings.vibration,
      onPress: () => toggleSetting('vibration'),
    },
    {
      id: 'showOnlineStatus',
      label: '显示在线状态',
      type: 'switch',
      value: settings.showOnlineStatus,
      onPress: () => toggleSetting('showOnlineStatus'),
    },
    {
      id: 'readReceipt',
      label: '发送已读回执',
      type: 'switch',
      value: settings.readReceipt,
      onPress: () => toggleSetting('readReceipt'),
    },
    {
      id: 'autoDownload',
      label: '自动下载图片',
      type: 'switch',
      value: settings.autoDownload,
      onPress: () => toggleSetting('autoDownload'),
    },
    {
      id: 'darkMode',
      label: '深色模式',
      type: 'switch',
      value: settings.darkMode,
      onPress: () => toggleSetting('darkMode'),
    },
    {
      id: 'language',
      label: '语言',
      type: 'arrow',
      onPress: () => {},
    },
    {
      id: 'privacy',
      label: '隐私协议',
      type: 'arrow',
      onPress: () => navigation.navigate('Privacy' as any),
    },
    {
      id: 'clearCache',
      label: '清除缓存',
      type: 'arrow',
      onPress: () => {},
    },
  ];

  return (
    <ScrollView style={styles.container}>
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>消息设置</Text>
        {settingItems.slice(0, 6).map((item) => (
          <View key={item.id} style={styles.item}>
            <Text style={styles.itemLabel}>{item.label}</Text>
            {item.type === 'switch' && item.value !== undefined ? (
              <Switch
                value={item.value}
                onValueChange={item.onPress}
                trackColor={{ false: '#ccc', true: '#c9a227' }}
                thumbColor={item.value ? '#fff' : '#fff'}
              />
            ) : (
              <TouchableOpacity onPress={item.onPress}>
                <Text style={styles.itemArrow}>›</Text>
              </TouchableOpacity>
            )}
          </View>
        ))}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>显示设置</Text>
        {settingItems.slice(6, 7).map((item) => (
          <View key={item.id} style={styles.item}>
            <Text style={styles.itemLabel}>{item.label}</Text>
            <Switch
              value={item.value}
              onValueChange={item.onPress}
              trackColor={{ false: '#ccc', true: '#c9a227' }}
              thumbColor={item.value ? '#fff' : '#fff'}
            />
          </View>
        ))}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>其他设置</Text>
        {settingItems.slice(7).map((item) => (
          <TouchableOpacity key={item.id} style={styles.arrowItem} onPress={item.onPress}>
            <Text style={styles.itemLabel}>{item.label}</Text>
            <Text style={styles.itemArrow}>›</Text>
          </TouchableOpacity>
        ))}
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>聊天记录设置</Text>
        <View style={styles.item}>
          <Text style={styles.itemLabel}>聊天记录上限</Text>
          <Text style={styles.itemValue}>{messageSize}天</Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  arrowItem: {
    alignItems: 'center',
    borderBottomColor: '#f5f5f5',
    borderBottomWidth: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  item: {
    alignItems: 'center',
    borderBottomColor: '#f5f5f5',
    borderBottomWidth: StyleSheet.hairlineWidth,
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  itemArrow: {
    color: '#ccc',
    fontSize: 24,
  },
  itemLabel: {
    color: '#333',
    flex: 1,
    fontSize: 16,
  },
  itemValue: {
    color: '#999',
    fontSize: 14,
  },
  section: {
    backgroundColor: '#fff',
    marginTop: 16,
  },
  sectionTitle: {
    color: '#999',
    fontSize: 14,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
});
